import Vue from 'vue';
Vue.filter('formatTime', function(unixTimestamp, type) {
    let dt = new Date(unixTimestamp * 1000);
    if (!Number(unixTimestamp) || Number(unixTimestamp) <= 0 || Number(unixTimestamp) == 1) {
        return '—';
    }
    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hours = dt.getHours();
    let minutes = dt.getMinutes();
    let seconds = dt.getSeconds();
    if (hours < 10) hours = '0' + hours;

    if (minutes < 10) minutes = '0' + minutes;

    if (seconds < 10) seconds = '0' + seconds;
    switch (type) {
        case 1:
            return hours + ':' + minutes + ':' + seconds; //小时:分钟:秒  格式
        case 2:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
        case 3:
            return year + '-' + month + '-' + day; //年-月-日 格式
        case 4:
            return hours + ':' + minutes + ':' + seconds;
        case 5:
            return hours + ':' + minutes;
        case 6:
            return year + '-' + month + '-' + day + ' 00:00:00';
        case 7:
            return year + '-' + month + '-' + day + ' 23:59:59';
        default:
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds; //年-月-日 小时:分钟:秒 格式
    }
});
Vue.filter('differenceTime', function(difference) {
    let year_1 = 3600 * 24 * 30 * 12;
    let month_1 = 3600 * 24 * 30;
    let day_1 = 3600 * 24;
    let hour_1 = 3600;
    let minute_1 = 60;
    let year = 0,
        month = 0,
        day = 0,
        hour = 0;
    if (!Number(difference) || Number(difference) <= 0) {
        return '-';
    } else if (difference < day_1) {
        // 小于一天
        hour = parseInt(difference / hour_1);
    } else if (difference < month_1) {
        // 小于一月
        day = parseInt(difference / day_1);
        hour = parseInt((difference % day_1) / hour_1);
    } else if (difference < year_1) {
        // 小于一年
        month = parseInt(difference / month_1);
        day = parseInt((difference % month_1) / day_1);
        hour = parseInt(((difference % month_1) % day_1) / hour_1);
    } else {
        // 大于一年
        year_1 = 365 * 24 * 60 * 60;
        year = parseInt(difference / year_1);
        month = parseInt((difference % year_1) / month_1);
        day = parseInt(((difference % year_1) % month_1) / day_1);
        hour = parseInt((((difference % year_1) % month_1) % day_1) / hour_1);
    }
    year = year == 0 ? '' : year + ' 年 ';
    month = month == 0 ? '0 月 ' : month + ' 月 ';
    day = day == 0 ? '0 天 ' : day + ' 天 ';
    hour = hour == 0 ? '0 小时 ' : hour + ' 小时 ';
    return year + month + day + hour;
});

Vue.filter('formatterKey', function(cardNumber){
    if (!cardNumber || typeof cardNumber !== 'string') {
         return '-';
    }
    const length = cardNumber.length;
    if (length >= 10) {
        const start = cardNumber.slice(0, 4);
        const end = cardNumber.slice(-4);
        const middle = '*'.repeat(8);
        return `${start}${middle}${end}`;
    }else if(length <= 0){
        return '-';
    }else {
        const start = cardNumber.slice(0, 3);
        const end = cardNumber.slice(-3);
        const middle = '*'.repeat(4);
        return `${start}${middle}${end}`;
    }
})



// WEBPACK FOOTER //
// ./src/plugins/filters.js